export const SPACING_CLASSES = ["indent", "indent-top", "indent-bottom"];

export const POSITIONAL_CLASSES = [
  "position-left",
  "position-center",
  "position-right",
];
